import { faFileLines, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { PillStyled } from './TrlPill.styles';

export const TrlPill = ({ label, variant, ...rest }) => {
  const getPillContent = () => {
    if (variant === 'open')
      return (
        <>
          {label}{' '}
          <FontAwesomeIcon style={{ fontSize: 10 }} icon={faFileLines} />
        </>
      );

    if (variant === 'delete')
      return <FontAwesomeIcon style={{ fontSize: 12 }} icon={faTrashCan} />;

    return label;
  };

  return <PillStyled variant={variant} label={getPillContent()} {...rest} />;
};

TrlPill.propTypes = {
  label: PropTypes.string,
  variant: PropTypes.string,
};
